export default __webpack_public_path__ + "static/media/logo_final _blue.1fbf04b8.jpg";